import React from 'react';
import {
  Box,
  Typography,
  Grid as MuiGrid,
  Paper,
  LinearProgress,
} from '@mui/material';
import { motion } from 'framer-motion';

const MotionPaper = motion.create(Paper);
const Grid = MuiGrid as any;

interface SkillCategory {
  name: string;
  skills: {
    name: string;
    level: number;
  }[];
}

const skillCategories: SkillCategory[] = [
  {
    name: 'Cloud & Infrastructure',
    skills: [
      { name: 'AWS Architecture', level: 8.5 },
      { name: 'Cloud Migration', level: 8.5 },
      { name: 'Terraform', level: 8.2 },
      { name: 'Kubernetes', level: 8 },
      { name: 'Microservices', level: 8 },
    ],
  },
  {
    name: 'AI & Machine Learning',
    skills: [
      { name: 'RAG Implementation', level: 8.2 },
      { name: 'LLM Integration', level: 8.2 },
      { name: 'Vector Database', level: 7.4 },
      { name: 'Computer Vision', level: 7.6 },
      { name: 'ML Model Development', level: 7 },
    ],
  },
  {
    name: 'Development & Data',
    skills: [
      { name: 'Python Development', level: 8.7 },
      { name: 'Node', level: 8.4 },
      { name: 'DB Architecture', level: 9 },
      { name: 'Data Pipeline Design', level: 9 },
      { name: 'API Architecture', level: 8.5 },
    ],
  },
  {
    name: 'Security & Architecture',
    skills: [
      { name: 'Security Architecture', level: 8.7 },
      { name: 'Cloud Security Design', level: 8.1 },
      { name: 'System Architecture', level: 8.8 },
      { name: 'DevSecOps', level: 7.1 },
      { name: 'Zero Trust', level: 7 },
    ],
  },
];

const Skills = () => {
  return (
    <Box sx={{ py: { xs: 2, md: 4 } }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Skills & Expertise
      </Typography>
      
      <Grid container spacing={4}>
        {skillCategories.map((category, index) => (
          <Grid key={index} sx={{ gridColumn: { xs: 'span 12', md: 'span 4' } }}>
            <MotionPaper
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              sx={{
                p: { xs: 2, md: 3 },
                height: '100%',
                backgroundColor: 'background.paper',
                borderRadius: 2,
              }}
            >
              <Typography variant="h6" component="h2" gutterBottom>
                {category.name}
              </Typography>
              
              <Box sx={{ mt: 2 }}>
                {category.skills.map((skill, i) => (
                  <Box key={i} sx={{ mb: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                      <Typography variant="body1">{skill.name}</Typography>
                      <Typography variant="body2" color="text.secondary">
                        {skill.level}/10
                      </Typography>
                    </Box>
                    <LinearProgress
                      variant="determinate"
                      value={skill.level * 10}
                      sx={{
                        height: 8,
                        borderRadius: 4,
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        '& .MuiLinearProgress-bar': {
                          borderRadius: 4,
                        },
                      }}
                    />
                  </Box>
                ))}
              </Box>
            </MotionPaper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Skills; 